import { registerComponent, getComponentConfig } from "helpers";

registerComponent(
  "my-registry",
  class AddToRegistry extends HTMLElement {
    constructor() {
      super();

      this.modal = this.closest("dialog");
      this.config = getComponentConfig(this);
      this.button = this.querySelector("button");

      this.button.addEventListener(
        "click",
        this.handleAddToRegistry.bind(this)
      );
    }

    async handleAddToRegistry() {
      const { product, variant, imageURL, variantUrl } = this.config;

      if (!product || !variant) {
        console.error("Product or variant data is missing.");
        return;
      }
      const myRegistrySdk = new MyRegistrySDK();

      const currentImageSrc =
        typeof imageURL === "string" ? imageURL : imageURL.src;

      const currentColor =
        variant.option1 === "Default Title" ? "" : variant.option1;

      if (myRegistrySdk && typeof myRegistrySdk.showPopup === "function") {
        try {
          const gift = {
            Title: variant.name,
            ImageUrl: currentImageSrc,
            URL: variantUrl,
            Price: variant.price / 100,
            Quantity: 1,
            SKU: variant.sku,
            CurrencyCode: "USD",
            Color: currentColor,
          };

          myRegistrySdk.setGift(gift);
          myRegistrySdk.showPopup();
          this.modal.close();
        } catch (error) {
          console.error("Error adding to registry:", error);
        }
      } else {
        console.error(
          "MyRegistrySDK is not initialized correctly or the method is not available."
        );
      }
    }
  }
);
